// Load Dependencies
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { configurationsStoreSelectors } from "../../../../store/store";

import { ActionCreator } from "../../../../../../actions/actions";
import FormSet from "../../../../../../utils/forms/components/FormSet";
import { ConfigurationsActionCreators } from "../../../../actions/actionCreators";
import { DenominationsList } from "../../../../reducers/denominations.reducer";
import { GlobalJackpotConfig } from "../../../../reducers/editingConfiguration.reducer";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import FormBoxes from "../../../../../../utils/forms/components/FormBoxes";

import "./GlobalJackpotConfigurationSection.component.scss";
import { defaultsGlobalJackpot } from "./FormBuild/GlobalJackpotConfigurationSection.defaults";

/* Load Forms */
import { globalJackpotBox } from "./FormBuild/GlobalJackpotConfigurationSection.forms";
import { ConfigurationsActionTypes } from "../../../../actions/actionTypes";

export interface GlobalJackpotConfigurationSectionProps {
    globalJackpotConfig: GlobalJackpotConfig[];
    gameInstances: any;
    fullSchema: any;
    schema: any;
    denominationsList: DenominationsList;
    updateGlobalJackpotConfig: ActionCreator;
    getGameInstances: ActionCreator;
    configSectionVisited: ActionCreator;
    editingConfiguration: any;
}

export interface GlobalJackpotConfigurationSectionState {
    globalJackpotConfig: any[];
    showDialog: boolean;
    indexToDelete: number;
    deleteCallback: any;
}

const defaultState = {
    globalJackpotConfig: [],
    showDialog: false,
    indexToDelete: null,
    deleteCallback: null
};

class GlobalJackpotConfigurationSection extends Component<
    GlobalJackpotConfigurationSectionProps,
    GlobalJackpotConfigurationSectionState
> {
    private previousGlobalJackpotValue = null;
    globalJackpotFormSet: React.RefObject<FormSet>;

    constructor(props) {
        super(props);

        this.state = defaultState;

        this.props.getGameInstances({
            subsidiary: this.props.editingConfiguration.subsidiary.id
        });

        this.globalJackpotFormSet = React.createRef();
    }

    componentDidMount() {
        this.props.configSectionVisited(
            ConfigurationsActionTypes.UPDATE_GLOBAL_JACKPOT_CONFIG
        );

        if (
            this.props.editingConfiguration.settings.settings.settings !==
                null &&
            this.props.editingConfiguration.settings.settings.settings
                .game_types.length !== 0
        ) {
            if (
                this.props.editingConfiguration.settings.settings.settings
                    .game_types.length == 1 &&
                !this.props.editingConfiguration.settings.settings.settings.game_types.includes(
                    "Bingo"
                )
            ) {
                this.props.updateGlobalJackpotConfig({
                    config: {},
                    isValid: true
                });
            }
        } else if (
            this.props.editingConfiguration.settings.settings.settings !==
                null &&
            this.props.editingConfiguration.settings.settings.settings
                .game_types.length === 0
        ) {
            this.props.updateGlobalJackpotConfig({
                config: {},
                isValid: false
            });
        }
    }

    onChange = formEvent => {
        this.previousGlobalJackpotValue = {
            values: { ...formEvent.values },
            isValid: formEvent.isValid
        };

        this.props.updateGlobalJackpotConfig({
            config: this.previousGlobalJackpotValue.values,
            isValid: this.previousGlobalJackpotValue.isValid
        });
    };

    addGlobalJackpot = () => {
        this.globalJackpotFormSet.current.onAdd(0);
    };

    render() {
        if (
            (this.props.editingConfiguration.settings.settings.settings !==
                null &&
                this.props.editingConfiguration.settings.settings.settings
                    .game_types.length == 0) ||
            (this.props.editingConfiguration.settings.settings.settings !==
                null &&
                !this.props.editingConfiguration.settings.settings.settings.game_types.includes(
                    "Bingo"
                ))
        ) {
            return (
                <div id="GlobalJackpotConfigurationSection">
                    <div className="row">
                        <div className="empty-prize-types">
                            <p>
                                <i className="icon-exclamation-circle-light"></i>
                                Bingo game type must be selected in General
                                Settings to be able to configure Global
                                Jackpots.
                            </p>
                        </div>
                    </div>
                </div>
            );
        }

        if (this.props.gameInstances.results.length == 0) {
            return (
                <div id="GlobalJackpotConfigurationSection">
                    <div className="loading" key="loading">
                        <Components.LoadingRipple width={100} height={100} />
                    </div>
                </div>
            );
        }

        const subForms = globalJackpotBox(this.props)({
            gameInstances: this.props.gameInstances.results,
            schema: this.props.schema,
            globalJackpotConfig: this.props.globalJackpotConfig
        });

        return (
            <div id="GlobalJackpotConfigurationSection">
                <FormBoxes
                    boxes={subForms}
                    onChange={this.onChange}
                    initialValues={
                        Object.keys(this.props.globalJackpotConfig).length > 0
                            ? this.props.globalJackpotConfig
                            : defaultsGlobalJackpot({
                                  schema: this.props.schema
                              })
                    }
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    globalJackpotConfig:
        configurationsStoreSelectors.globalJackpotConfig(state),
    schema: configurationsStoreSelectors.globalJackpotSchema(state),
    fullSchema: configurationsStoreSelectors.schema(state),
    denominationsList: configurationsStoreSelectors.denominationsList(state),
    gameInstances: configurationsStoreSelectors.gameInstances(state),
    editingConfiguration:
        configurationsStoreSelectors.editingConfiguration(state)
});

const mapDispatchToProps = {
    updateGlobalJackpotConfig:
        ConfigurationsActionCreators.updateGlobalJackpotConfig,
    getGameInstances: ConfigurationsActionCreators.getGameInstances,
    configSectionVisited: ConfigurationsActionCreators.configSectionVisited
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GlobalJackpotConfigurationSection);
